<template></template>

<script>
export default {
  computed: {
    userPlanSlug() {
      if (this.$store.getters.userPlan) {
        return this.$store.getters.userPlan.slug
      }
      return null
    },
    utilityPlanSlug() {
      if (this.$store.getters.utilityPlan) {
        return this.$store.getters.utilityPlan.slug
      }
      return null
    },
    planConfig() {
      return this.$store.getters.planConfig
    },
    maxTerms() {
      return this.$store.getters.planConfig.maxTerms
    },
    allowCustomTerms() {
      return this.$store.getters.planConfig.allowCustomTerms
    },
    restrictStartMonth() {
      return this.$store.getters.planConfig.restrictStartMonth
    },
    allowCustomFacilityProfile() {
      return this.$store.getters.planConfig.allowCustomFacilityProfile
    },
    termLength() {
      return this.$store.getters.termLength
    },
    activeTermCount() {
      let activeTerms = this.termLength
      activeTerms = activeTerms.filter(item => {
        return item.value != ''
      })
      return activeTerms.length
    }
  },
  methods: {
    manageTermLengths() {
      // Trim term length values if plan config disallows current values
      let terms = [
        {
          id: 1,
          value: ''
        },
        {
          id: 2,
          value: ''
        },
        {
          id: 3,
          value: ''
        }
      ]

      for (let i = 0; i < 3; ++i) {

        if (this.termLength[i].value && i < this.maxTerms) {
          
          // If custom terms aren't allowed, the translated term length must be 12, 24, or 36
          if (!this.allowCustomTerms) {

            switch(this.termLength[i].value) {
              case 12:
              case 24:
              case 36:
                terms[i].value = parseInt(this.termLength[i].value)
                break

              default:
                terms[i].value = ''
            }
          } else {
            terms[i].value = parseInt(this.termLength[i].value)
          }
        }
      } 

      this.$store.dispatch('setTermLength', terms)
    }
  },
  watch: {
    // @todo The following plan config should be set from the
    // config data available in store.state.plans which is loaded
    // from the API/database.
    userPlanSlug(plan) {

      let planConfig = {
        maxTerms: 1,
        allowCustomTerms: false,
        restrictStartMonth: true,
        allowCustomFacilityProfile: false,
        priceRequestSlots: false,
        exportable: false,
      }

      switch(plan) {
        case 'free':
          break

        case 'free-registered':
          planConfig.priceRequestSlots = 1
          break

        case 'basic':
          planConfig.maxTerms = 3
          planConfig.allowCustomFacilityProfile = true
          planConfig.priceRequestSlots = 10
          planConfig.exportable = true
          break

        case 'premium':
        case 'premium-legacy-1':
          planConfig.maxTerms = 3
          planConfig.allowCustomTerms = true
          planConfig.restrictStartMonth = false
          planConfig.allowCustomFacilityProfile = true
          planConfig.priceRequestSlots = 99999 // no real limit
          planConfig.exportable = true
          break
      }

      this.$store.dispatch('setPlanConfig', planConfig)
    },
    
    // @todo The following plan config should be set from the
    // config data available in store.state.plans which is loaded
    // from the API/database.
    utilityPlanSlug(newPlan, oldPlan) {

      let planConfig = {
        maxTerms: 1,
        allowCustomTerms: false,
        restrictStartMonth: true,
        allowCustomFacilityProfile: false,
        priceRequestSlots: this.planConfig.priceRequestSlots, // Pass through non-utility dependent config items,
        exportable: false
      }

      switch(newPlan) {
        case 'free':
          break

        case 'free-registered':
          if (['basic', 'premium', 'premium-legacy-1'].includes(this.userPlanSlug)) {
            planConfig.exportable = true
          }
          break

        case 'basic':
          planConfig.maxTerms = 3
          planConfig.allowCustomFacilityProfile = true
          planConfig.exportable = true
          break

        case 'premium':
        case 'premium-legacy-1':
          planConfig.maxTerms = 3
          planConfig.allowCustomTerms = true
          planConfig.restrictStartMonth = false
          planConfig.allowCustomFacilityProfile = true
          planConfig.exportable = true
          break
      }

      this.$store.dispatch('setPlanConfig', planConfig)

    },
    maxTerms(value) {
      this.manageTermLengths()
    }
  }
}
</script>
